import React, { useEffect } from "react";
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";

import moment from "moment";
import {
  hasOpenUnits,
  isNumber,
  numberWithCommas,
  showVPSFundLogic,
} from "../../../utils/customFunction";
import { useHistory } from "react-router-dom";
import { set } from "mobx";
import {
  getFundByAmc,
  getFundExpenses,
} from "../../../stores/services/funds.service";
import NumberFormat from "react-number-format";
import { getAllCompanies } from "../../../stores/services/company.service";
interface ViewFundProps {
  child?: any;
}

const ViewFund = ({ child = "" }: ViewFundProps) => {
  const arrFundManagement = [
    {
      value: "main_fund",
      label: "Main Fund",
    },
    {
      value: "sub_fund",
      label: "Sub Fund",
    },
    {
      value: "plan",
      label: "Plan",
    },
  ];

  const history = useHistory();
  //hooks for getting all inputs from user
  const [companySignatory, setCompanySignatory] = useState<any>([
    {
      name: "",
      cnic: "",
      contact_no: "",
    },
  ]);
  const [authorizerPF, setAuthorizerPF] = useState<any>([
    {
      cnic: "",
      email: "",
      contact_no: "",
    },
  ]);
  const [companyName, setCompanyName] = useState<any>();
  const [NTN, setNTN] = useState("");
  const email = sessionStorage.getItem("email") || "";
  const [fundName, setFundName] = useState("");
  const [code, setCode] = useState("");
  const [amcName, setAmcName] = useState("");
  const [fundType, setFundType] = useState("");
  const [fundDividendPeriod, setFundDividendPeriod] = useState("");
  const [riskFactor, setRiskFactor] = useState("");
  const [trustee, setTrustee] = useState("");
  const [incorporationDate, setIncorporationDate] = useState("");
  const [revocationDate, setRevocationDate] = useState("");
  const [psxListing, setPsxListing] = useState("");
  const [moneyMarket, setMoneyMarket] = useState<any>([]);
  const [termDeposit, setTermDeposit] = useState<any>([]);
  const [nav, setNav] = useState("");
  const [faceValue, setFaceValue] = useState("");
  const [cdc_participant_id, setCDCParticipantID] = useState("");
  const [cdc_account_number, setCDCAccountNumber] = useState("");
  const [expenses, setExpenses] = useState<any>([]);
  const [NCCPLCode, setNCCPLCode] = useState("");
  const [fundManagement, setFundManagement] = useState("");
  const [fund, setFund] = useState("");
  const [revocate, setRevocate] = useState(false);
  const [offerPrice, setOfferPrice] = useState("");
  const [redemptionPrice, setRedemptionPrice] = useState("");
  const [outstandingUnits, setOutstandingUnits] = useState("");
  const [managementFee, setManagementFee] = useState("");
  const [sstmanagementfee, setSstManagementFee] = useState("");
  const [amcReimbursementExp, setReinbursementExp] = useState("");
  const [sellingMarketingExp, setSellingMarketingExp] = useState("");
  const [secpFee, setSECPFee] = useState("");
  const [secpSupervisoryFee, setSECPSupervisoryFee] = useState("");
  const [sstTrusteeFee, setSSTTrusteeFee] = useState("");
  const [saleLoad, setSaleLoad] = useState("");
  const [backendLoad, setBackendLoad] = useState("");
  const [contingentLoad, setContingentLoad] = useState("");
  const [sstSales, setSSTSales] = useState("");
  const [accountOperation, setAccountOperation] = useState("");
  const [loanInstallment, setLoanInstallment] = useState<any>("");
  const [employeeContribution, setEmployeeContribution] = useState<any>("");
  const [employerContribution, setEmployerContribution] = useState<any>("");
  const [loanAgaintPF, setLoanAgaintPF] = useState<any>("");
  let [slabData, setSlabData] = useState<any>([]);
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const [allFunds, setAllFunds] = useState<any>([]);
  const [typeVPS, setTypeVPS] = useState("");
  const [loanRefundable, setLoanRefundable] = useState(false);
  const [loadingCompany, setLoadingCompany] = useState(false);

  React.useEffect(() => {
    const obj = JSON.parse(sessionStorage.getItem("fundObj") || "");

    const fetchAllCompanies = async () => {
      try {
        setLoadingCompany(true);
        const resp = await getAllCompanies({ email, fetch_all: "all" });

        if (resp.data.status === 200) {
          let company: any = resp.data?.data?.find(
            (data: any) => data.company_code === obj.company_name,
          );

          company = {
            ...company,
            value: company?.company_code,
            label: `${company?.name_of_company} (${company?.company_code})`,
          };
          setCompanyName(company);
        }
        setLoadingCompany(false);
      } catch (error) {
        setLoadingCompany(false);
      }
    };

    if (obj.company_name) fetchAllCompanies();

    setRiskFactor(obj?.risk_factor || "");
    setFundName(obj.fund_name);
    setCode(obj.symbol_code.replace("FUND_", ""));
    setNav(obj.nav);
    setFaceValue(obj.face_value);
    setAmcName(obj.amc_code);
    setFundType(obj.nature);
    setFundDividendPeriod(obj.dividend_period);
    setIncorporationDate(
      obj.date_of_incorporation?.toString()?.split("T")[0] || "",
    );
    setRevocationDate(obj.date_of_revocation?.toString()?.split("T")[0] || "");
    setRevocate(obj?.revocate ? true : false);
    setSSTTrusteeFee(obj.sst_trustee_percentage || 0);
    setSlabData(JSON.parse(obj.fee_slab || "[]"));
    setPsxListing(obj.psx_listing);
    if (obj.money_market !== "" && obj.money_market !== "[]") {
      try {
        console.log(obj);

        console.log(JSON.parse(obj.money_market));
        setMoneyMarket(JSON.parse(obj.money_market));
      } catch (error: any) {
        console.log(error.message);
        console.log(error);
      }
    }
    if (obj.stock_market !== "" && obj.stock_market !== "[]") {
      // fully sold / reversed equity positions stay behind with 0 units - don't list them
      setStockMarket(JSON.parse(obj.stock_market).filter(hasOpenUnits));
    }
    if (obj.term_deposit !== "" && obj.term_deposit !== "[]") {
      setTermDeposit(JSON.parse(obj.term_deposit));
    }

    setCDCParticipantID(obj.cdc_participant_id);
    setCDCAccountNumber(obj.cdc_account_number);

    setOfferPrice(obj.offer_price);
    setRedemptionPrice(obj.redemption_price);
    setOutstandingUnits(obj.outstanding_units);
    setManagementFee(obj.management_fee_percentage);
    setSstManagementFee(obj.sst_on_management_fee_percentage);
    setReinbursementExp(obj.amc_reimbursement_exp_percentage);
    setSellingMarketingExp(obj.selling_and_marketing_exp_percentage);
    setSECPFee(obj.secp_fee_percentage);
    setSECPSupervisoryFee(obj.secp_supervisory_fee_percentage);
    setSaleLoad(obj.sale_load_percentage || 0);
    setBackendLoad(obj.backend_load_percentage || 0);
    setContingentLoad(obj.contingent_load_percentage || 0);
    setSSTSales(obj.sst_sale_backend_contingent_load_percentage || 0);
    setAccountOperation(obj.accounts_operations_percentage || 0);
    setNCCPLCode(obj?.nccpl_code || "");
    setTrustee(obj?.trustee || "");
    setFundManagement(obj?.fund_type || "");
    setFund(obj?.parent_fund || "");
    setLoanInstallment(obj?.loan_installement || 0);
    setEmployeeContribution(obj?.employee_contribution || 0);
    setEmployerContribution(obj?.employer_contribution || 0);
    setLoanAgaintPF(obj?.loan_against_pf || 0);
    setTypeVPS(obj?.type_VPS || "");
    setLoanRefundable(obj?.loan_refundable || false);
    setNTN(obj?.ntn || "");
    setCompanySignatory(obj?.company_signatory || []);
    setAuthorizerPF(obj?.authorizer_of_pf || []);
  }, []);

  const getExpenses = async () => {
    try {
      const response = await getFundExpenses(
        email,
        sessionStorage.getItem("amc_code") || "",
        JSON.parse(sessionStorage.getItem("fundObj") || "").symbol_code.replace(
          "FUND_",
          "",
        ),
      );
      if (response.status === 200 && response.data.status === 200)
        setExpenses(response.data.data);
    } catch (err: any) {}
  };

  useEffect(() => {
    getExpenses();
  }, []);

  const getAllFunds = async (Valueis = "") => {
    setFundLoading(true);
    try {
      const response = await getFundByAmc(
        email,
        amcCode,
        // fund_code?.length > 0 ? fund_code : ""
        "",
        "",
      );
      setAllFunds(response.data.data);
    } catch (err: any) {
    } finally {
      setFundLoading(false);
    }
  };
  React.useEffect(() => {
    getAllFunds();
  }, []);

  const [stockMarket, setStockMarket] = useState<any>([]);
  const renderFundDataInTable = () => {
    return moneyMarket.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.code}</td>
          <td>{items.security_type}</td>
          <td>{items.name}</td>
          <td>{items.issue_date}</td>
          <td>{items.maturity_date}</td>
          <td>{numberWithCommas(items.coupon_rate || "")}</td>
          <td>{numberWithCommas(items.yield || "")}</td>
          <td>{numberWithCommas(items.coupon_payment || "")}</td>
          <td>{numberWithCommas(items.coupon_days || "")}</td>
          <td>{numberWithCommas(items.mmface_value || "")}</td>
          <td>{numberWithCommas(items.total_face_value || "")}</td>
          {/* <td>{numberWithCommas(items.price || '')}</td> */}
          <td>{numberWithCommas(items.units || "")}</td>
          <td>{numberWithCommas(items.average_cost_per_unit || "")}</td>
          <td>
            {" "}
            {numberWithCommas(items.total_amount || "") &&
              numberWithCommas(parseFloat(items.total_amount).toFixed(4))}{" "}
          </td>
          <td> {numberWithCommas(items.market_rate_per_unit || "")} </td>
          <td> {numberWithCommas(items.market_value || "")} </td>
          <td> {numberWithCommas(items.unrealized_gain_loss || "")} </td>
          {/* <td> {numberWithCommas(items.unrealized_gain_loss || '')} </td> */}
          <td>
            {" "}
            {numberWithCommas(
              items.investment_percentage_market_value || "",
            )}{" "}
          </td>
          <td> {numberWithCommas(items.days_of_maturity || "")} </td>
          <td> {numberWithCommas(items.unredeem_value || "")} </td>
          <td> {numberWithCommas(items.principal_amount || "")} </td>
        </tr>
      );
    });
  };

  const renderEquityInTable = () => {
    return stockMarket.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.code}</td>
          <td>{items.market}</td>
          {/* <td>{numberWithCommas(items.close_rate || '') && numberWithCommas(parseFloat(items.close_rate).toFixed(2))}</td> */}
          <td>
            {numberWithCommas(items.total_units || "") &&
              numberWithCommas(items.total_units || "")}
          </td>
          <td>
            {numberWithCommas(items.unit || "") &&
              numberWithCommas(items.unit || "")}
          </td>
          <td>{numberWithCommas(items.average_cost_per_unit)}</td>
          <td>
            {numberWithCommas(items.amount || "") &&
              numberWithCommas(parseFloat(items.amount).toFixed(4))}
          </td>
          <td>{numberWithCommas(items.market_rate_per_unit)}</td>
          <td>{numberWithCommas(items.market_value)}</td>
          <td>{numberWithCommas(items.unrealized_gain_loss)}</td>
          <td>{numberWithCommas(items.investment_percentage_market_value)}</td>
        </tr>
      );
    });
  };

  const renderTermDepositInTable = () => {
    return termDeposit.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.code}</td>
          <td>{items.name}</td>
          <td>{numberWithCommas(items.principal_amount || "")}</td>
          <td>{numberWithCommas(items.interest_rate || "")}</td>
          <td>{moment(items.from_date).format("DD-MM-YYYY")}</td>
          <td>{moment(items.to_date).format("DD-MM-YYYY")}</td>
          <td>{items.bank}</td>
          <td>{items.branch}</td>
        </tr>
      );
    });
  };

  const renderFeeDataInTable = () => {
    return slabData.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{numberWithCommas(isNumber(items.amountFrom))}</td>
          <td>{numberWithCommas(isNumber(items.amountTo))}</td>
          <td className="text-right">
            {parseFloat(isNumber(items.rate)).toFixed(4)}
          </td>
          <td className="text-right">
            {numberWithCommas(isNumber(items.fixedAmmount))}
          </td>
        </tr>
      );
    });
  };

  const selectedFundManagement: any = React.useMemo(() => {
    const valueIs: any = arrFundManagement?.find(
      (ele) => ele?.value == fundManagement,
    );
    return valueIs ? valueIs?.label : null;
  }, [fundManagement]);

  const selectedFundName: any = React.useMemo(() => {
    const selectedFund: any = allFunds.find(
      (item) => item?._id === fund || item?.symbol_code === fund,
    );
    return selectedFund && selectedFund.nature === "Special Managed Account"
      ? `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`
      : selectedFund
        ? `${selectedFund.fund_name} (${selectedFund.symbol_code})`
        : null;
  }, [allFunds, fund]);

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              {child === "" && (
                <div className="input-holder">
                  <h4 className="card-title">
                    <i
                      className="fa fa-angle-left mr-1 pointer"
                      onClick={() => {
                        history.replace("/admin/funds");
                      }}
                    ></i>
                    View - Funds
                  </h4>
                  <Link
                    to="/admin/funds"
                    className="t-3 ml-auto btn btn-primary btn-sm"
                    replace
                  >
                    <i className="fa fa-eye mr-2"></i> View All
                  </Link>
                </div>
              )}

              <Row>
                <Col md="6">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Fund Details</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group  ">
                        <label>
                          Company Name <span className="color-amber">*</span>
                        </label>
                        <div>
                          <input
                            className="form-control"
                            value={companyName?.label || ""} // Take first element instead of array
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Fund Code</label>
                        <div className="">
                          <input
                            type="text"
                            className="form-control"
                            value={code}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Fund Name</label>
                        <div className="">
                          <input
                            type="text"
                            className="form-control"
                            value={fundName}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Category / Type of Fund</label>
                        <div className="">
                          <input
                            type="text"
                            className="form-control"
                            value={fundType}
                          />
                        </div>
                      </div>

                      {(fundType == "" || fundType !== "Provident Fund") && (
                        <>
                          <div className="form-group">
                            <label>Dividend Period</label>
                            <div className="">
                              <input
                                type="text"
                                className="form-control"
                                value={fundDividendPeriod}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Risk Factor</label>
                            <div className="">
                              <input
                                type="text"
                                className="form-control"
                                value={riskFactor}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                {/* {companyName && fundType && fundType === "Provident Fund" && (
                  <Col md="6">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Company</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col md="6">
                            <div className="form-group">
                              <label>Company Name</label>
                              <div>
                                <input
                                  type="text"
                                  className={`form-control  w-100 `}
                                  value={companyName.label}
                                  readOnly
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-group">
                              <label>NTN</label>
                              <div>
                                <input
                                  type="text"
                                  className={`form-control  w-100 `}
                                  value={companyName?.ntn || ""}
                                  readOnly
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                              <h1 className="mb-2">Company Signatory</h1>
                            </div>
                            {companyName?.amc_signatories?.map((ele, index) => {
                              return (
                                <Row>
                                  <Col>
                                    <div className="form-group">
                                      <label>Name</label>
                                      <div>
                                        <input
                                          type="text"
                                          className={`form-control w-100 `}
                                          value={ele?.name}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col>
                                    <div className="form-group">
                                      <label>CNIC</label>
                                      <div>
                                        <input
                                          type="text"
                                          className={`form-control w-100 `}
                                          value={ele?.cnic}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col>
                                    <div className="form-group">
                                      <label>Contact No</label>
                                      <div>
                                        <input
                                          type="text"
                                          className={`form-control w-100 `}
                                          value={ele?.contact_no}
                                          readOnly
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })}
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                              <h1 className="mb-2">PF Fund Trustee</h1>
                            </div>
                            {companyName.txn_creator_field?.map(
                              (ele, index) => {
                                return (
                                  <Row>
                                    <Col>
                                      <div className="form-group">
                                        <label>Name</label>
                                        <div>
                                          <input
                                            type="text"
                                            className={`form-control w-100 `}
                                            value={ele?.name}
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col>
                                      <div className="form-group">
                                        <label>CNIC</label>
                                        <div>
                                          <input
                                            type="text"
                                            className={`form-control w-100 `}
                                            value={ele?.cnic}
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col>
                                      <div className="form-group">
                                        <label>Email</label>
                                        <div>
                                          <input
                                            type="text"
                                            className={`form-control w-100 `}
                                            value={ele?.email}
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col>
                                      <div className="form-group">
                                        <label>Contact No</label>
                                        <div>
                                          <input
                                            type="text"
                                            className={`form-control w-100 `}
                                            value={ele?.contact_no}
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                );
                              }
                            )}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                )} */}

                {(fundType === "" || fundType !== "Provident Fund") && (
                  <Col md="6">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">
                          Incorporation
                          {/* <FormGroup check>
                          <Label
                            style={{
                              top: "2px"
                            }}
                            check>
                            <Input
                              type="checkbox"
                              checked={revocate}
                              readOnly
                              onChange={(e) => {
                                setRevocate(e.target.checked)
                              }}
                            />
                            <span className="form-check-sign" />
                            Revocate
                          </Label>
                        </FormGroup> */}
                        </CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="form-group  ">
                          <label>Date of Incorporation</label>
                          <div className="">
                            <input
                              type="text"
                              className="form-control"
                              value={moment(incorporationDate).format(
                                "DD-MM-YYYY",
                              )}
                            />
                          </div>
                        </div>

                        {revocate && (
                          <div className="form-group  ">
                            <label>Date of Revocation</label>
                            <div className="">
                              <input
                                type="text"
                                className="form-control"
                                value={moment(revocationDate).format(
                                  "DD-MM-YYYY",
                                )}
                              />
                            </div>
                          </div>
                        )}

                        <Row>
                          <Col md="6">
                            <div className="form-group  ">
                              <label>Opening NAV</label>
                              <div className="">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={nav}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-group  ">
                              <label>Face Value</label>
                              <div className="">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={faceValue}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6">
                            <div className="form-group">
                              <label>CDC Participant ID</label>
                              <div>
                                <input
                                  type="text"
                                  className={`form-control  w-100 `}
                                  value={cdc_participant_id}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-group">
                              <label htmlFor="">CDC Account Number </label>
                              <input
                                type="text"
                                className="form-control"
                                value={cdc_account_number}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6">
                            <div className="form-group  ">
                              <label>NCCPL Code for fund </label>
                              <div className="">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={NCCPLCode}
                                  readOnly
                                />
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-group  ">
                              <label>Trustee</label>
                              <div>
                                <input
                                  type="text"
                                  className={`form-control  w-100 `}
                                  readOnly
                                  value={trustee}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <div className="">
                          <label>PSX Listing</label>
                          <div className=" ">
                            <div>
                              <FormGroup check className="form-check-radio">
                                <Label check>
                                  <Input
                                    defaultChecked
                                    id="listed"
                                    name="listed"
                                    value="true"
                                    checked={true}
                                    type="radio"
                                  />
                                  <span className="form-check-sign" />
                                  {psxListing === "true"
                                    ? "Listed"
                                    : "UnListed"}
                                </Label>
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>

              {showVPSFundLogic[fundType] && fundManagement && (
                <Row>
                  <Col md="12">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">
                          <div className="d-flex justify-content-between align-items-center">
                            {fundType === "Provident Fund"
                              ? "Loan Application Details"
                              : "Additional Details"}
                            {fundType === "Provident Fund" && (
                              <div className="form-group">
                                <FormGroup
                                  check
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                  }}
                                >
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      checked={loanRefundable}
                                      readOnly
                                    />
                                    <span className="form-check-sign" />
                                    Refundable Loan
                                  </Label>
                                </FormGroup>
                              </div>
                            )}
                          </div>
                        </CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          {fundType !== "Provident Fund" && (
                            <Col md="4">
                              <div className="form-group ">
                                <label>Fund Management</label>
                                <div>
                                  <input
                                    type="text"
                                    className={`form-control  w-100 `}
                                    readOnly
                                    value={selectedFundManagement}
                                  />
                                </div>
                              </div>
                            </Col>
                          )}
                          {fundType !== "Provident Fund" &&
                            fundManagement &&
                            fundManagement !== "main_fund" && (
                              <>
                                <Col md="4">
                                  <div className="form-group  ">
                                    <label>Parent Fund</label>
                                    <div>
                                      {fundLoading ? (
                                        <div className={`form-control w-100`}>
                                          <i
                                            className="fa fa-spinner fa-spin fa-3x"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      ) : (
                                        <input
                                          type="text"
                                          className={`form-control  w-100 `}
                                          readOnly
                                          value={selectedFundName}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </>
                            )}

                          {fundType === "Provident Fund" && (
                            <>
                              <Col md="4">
                                <div className="form-group">
                                  <div
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <label>
                                      Loan Against Employee Contribution
                                    </label>
                                    <div>
                                      <NumberFormat
                                        thousandSeparator
                                        decimalScale={4}
                                        readOnly
                                        value={employeeContribution}
                                        className="form-control pr-4 text-right w-100"
                                      />
                                    </div>
                                    <span
                                      className={`input-group-text px-0`}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "70%",
                                        transform: "translateY(-50%)",
                                        background: "transparent",
                                        border: "none",
                                        pointerEvents: "none",
                                      }}
                                    >
                                      %
                                    </span>
                                  </div>
                                </div>
                              </Col>
                              <Col md="4">
                                <div className="form-group">
                                  <div
                                    style={{
                                      position: "relative",
                                    }}
                                  >
                                    <label>
                                      Loan Against Employer Contribution
                                    </label>
                                    <div>
                                      <NumberFormat
                                        thousandSeparator
                                        decimalScale={4}
                                        readOnly
                                        value={employerContribution}
                                        className="form-control pr-4 text-right w-100"
                                      />
                                    </div>
                                    <span
                                      className={`input-group-text px-0`}
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "70%",
                                        transform: "translateY(-50%)",
                                        background: "transparent",
                                        border: "none",
                                        pointerEvents: "none",
                                      }}
                                    >
                                      %
                                    </span>
                                  </div>
                                </div>
                              </Col>
                              {/* <Col md="4">
                                                                                    <div className="form-group  ">
                                                                                      <label>Loan Against PF %</label>
                                                                                      <div>
                                                                                        <NumberFormat
                                                                                          thousandSeparator
                                                                                          decimalScale={4}
                                                                                          isAllowed={(values) => {
                                                                                            const { value } = values;
                                                                                            let returnVal;
                                                                                            if (
                                                                                              (+value <= 100 && +value > 0) ||
                                                                                              value === ""
                                                                                            ) {
                                                                                              returnVal = true;
                                                                                            } else {
                                                                                              returnVal = false;
                                                                                            }
                                                                                            return returnVal;
                                                                                          }}
                                                                                          onValueChange={({ value }) => {
                                                                                            setLoanAgaintPF(
                                                                                              value?.replaceAll(",", "")
                                                                                            );
                                                                                          }}
                                                                                          value={loanAgaintPF}
                                                                                          className="form-control text-right w-100"
                                                                                        />
                                                                                      </div>
                                                                                    </div>
                                                                                  </Col> */}
                              {loanRefundable && (
                                <Col md="4">
                                  <div className="form-group  ">
                                    <div
                                      style={{
                                        position: "relative",
                                      }}
                                    >
                                      <label>No of Installment</label>
                                      <div>
                                        <NumberFormat
                                          decimalScale={0}
                                          className={`form-control pr-4 text-right w-100`}
                                          value={loanInstallment}
                                          readOnly
                                        />
                                        <span
                                          className={`input-group-text px-0`}
                                          style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "70%",
                                            transform: "translateY(-50%)",
                                            background: "transparent",
                                            border: "none",
                                            pointerEvents: "none",
                                          }}
                                        >
                                          #
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
              {(fundType === "" || fundType !== "Provident Fund") && (
                <>
                  <Row>
                    <Col md>
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Detail</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <Row>
                            <Col md="4">
                              <div className="form-group  ">
                                <label>Offer Price</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={offerPrice}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Redemption Price</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={redemptionPrice}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>OutStanding Units</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100`}
                                    value={outstandingUnits}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Management Fee%</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={managementFee}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="form-group  ">
                                <label>SST on Management Fee %</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={sstmanagementfee}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>AMC Reimbursement Exp % </label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={amcReimbursementExp}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Selling {"&"} Marketing Exp % </label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={sellingMarketingExp}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="form-group  ">
                                <label>SECP Fee % </label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100`}
                                    value={secpFee}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>SECP Supervisory Fee % </label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={secpSupervisoryFee}
                                  />
                                </div>
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="form-group  ">
                                <label>SST on Trustee Fee %</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={sstTrusteeFee}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Sales Load %</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={saleLoad}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Backend Load %</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={backendLoad}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Contingent Load %</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={contingentLoad}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>
                                  SST on Sales/Backend/Contingent Load %
                                </label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={sstSales}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col md="4">
                              <div className="form-group  ">
                                <label>Accounts & Operation Expense %</label>
                                <div>
                                  <input
                                    type="number"
                                    className={`form-control  w-100 `}
                                    value={accountOperation}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    {slabData.length > 0 && (
                      <Col md="12">
                        <Card>
                          <CardHeader>
                            <CardTitle tag="h4">Trustee Fee Slab</CardTitle>
                          </CardHeader>
                          <CardBody>
                            <div className="table-responsive">
                              {slabData.length > 0 && (
                                <div className="input-size-pos mb-3 mt-2 ">
                                  <table className="table   ">
                                    <thead>
                                      <tr>
                                        <th>Slab From</th>
                                        <th>Slab To</th>
                                        <th className="text-right">Rate %</th>
                                        <th className="text-right">
                                          Fix Amount
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>{renderFeeDataInTable()}</tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col md="12">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Expenses</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <Row className="ml-2">
                            <Col>
                              <div className="table-responsive">
                                {expenses && expenses.length > 0 && (
                                  <div className="input-size-pos mb-3 mt-2">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th>Sr#</th>
                                          <th>Ledger Code</th>
                                          <th>Ledger</th>
                                          <th>Asso. Ledger Code</th>
                                          <th>Asso. Ledger</th>
                                          {/* <th>Daily Fee</th>
                                                    <th>Weekly Fee</th>
                                                    <th>Monthly Fee</th> */}
                                          <th>Quarterly Charge</th>
                                          <th>Quarterly Days</th>
                                          <th>Half Yearly Charge</th>
                                          <th>Half Yearly Days</th>
                                          <th>Yearly Charge</th>
                                          <th>Yearly Days</th>
                                          <th>Dependent on</th>

                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {expenses.map((item, index) => {
                                          return (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{item.ledger_code}</td>
                                              <td>{item.ledger_name}</td>
                                              <td>
                                                {item.related_ledger_code}
                                              </td>
                                              <td>
                                                {item.related_ledger_name}
                                              </td>
                                              {/* <td>
                                                          {numberWithCommas(item.daily_fee)}
                                                        </td>
                                                        <td>
                                                          {numberWithCommas(item.weekly_fee)}
                                                        </td>
                                                        <td>
                                                          {numberWithCommas(item.monthly_fee)}
                                                        </td> */}
                                              <td>
                                                {numberWithCommas(
                                                  item.quarterly_fee,
                                                )}
                                              </td>
                                              <td>{item.quarterly_days}</td>

                                              <td>
                                                {numberWithCommas(
                                                  item.half_yearly_fee,
                                                )}
                                              </td>
                                              <td>{item.half_yearly_days}</td>

                                              <td>
                                                {numberWithCommas(
                                                  item.yearly_fee,
                                                )}
                                              </td>
                                              <td>{item.yearly_days}</td>

                                              <td>
                                                {item.incorporation
                                                  ? "Incorporation"
                                                  : "Yearly"}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  <Row>
                    {moneyMarket.length > 0 && (
                      <Col md="12">
                        <Card>
                          <CardHeader>
                            <CardTitle tag="h4">
                              Money Market Portfolio
                            </CardTitle>
                          </CardHeader>
                          <CardBody>
                            <div className="input-size-pos mb-3 ">
                              <h3></h3>
                              <div className="table-responsive ">
                                <table className="table ">
                                  <thead>
                                    <tr>
                                      <th>Symbol</th>
                                      <th>Security Type</th>
                                      <th>Name</th>
                                      <th>Issue Date</th>
                                      <th>Maturity Date</th>
                                      <th>Coupon Rate %</th>
                                      <th>Yield %</th>
                                      <th>Coupon Payment/Year</th>
                                      <th>Coupon Days</th>
                                      <th>Money Market Face Value/Unit</th>
                                      <th>Total Face Value</th>
                                      <th>Units</th>
                                      <th>Avg Cost/Unit</th>
                                      <th>Total Cost / Amount</th>
                                      <th>Market Rate/Unit</th>
                                      <th>Market Value</th>
                                      <th>Unrealized Gain/(Loss)</th>
                                      <th>Investment as % of Market Value</th>
                                      <th>Maturity Days</th>
                                      <th>Unredeemed Value</th>
                                      <th>Principal Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>{renderFundDataInTable()}</tbody>
                                </table>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    )}

                    {stockMarket.length > 0 && (
                      <Col md="12">
                        <Card>
                          <CardHeader>
                            <CardTitle tag="h4">
                              Stock Market Portfolio
                            </CardTitle>
                          </CardHeader>
                          <CardBody>
                            <div className="input-size-pos mb-3 ">
                              <h3></h3>
                              <div className="table-responsive ">
                                <table className="table ">
                                  <thead>
                                    <tr>
                                      <th>Symbol</th>
                                      <th>Market</th>
                                      <th>Total Units</th>
                                      <th>Available Units</th>
                                      <th>Average Cost / Unit</th>
                                      <th>Total Cost / Amount</th>
                                      <th>Market Rate/Unit</th>
                                      <th>Market Value</th>
                                      <th>Unrealized Gain/(Loss)</th>
                                      <th>Investment as % Market Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>{renderEquityInTable()}</tbody>
                                </table>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    )}
                  </Row>
                </>
              )}

              {termDeposit.length > 0 && (
                <Row>
                  <Col md="12">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Term Deposit Portfolio</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="input-size-pos mb-3 ">
                          <h3></h3>
                          <div className="table-responsive ">
                            <table className="table ">
                              <thead>
                                <tr>
                                  <th>Code</th>
                                  <th>Name</th>
                                  <th>Principal Amount</th>
                                  <th>Interest Rate</th>
                                  <th>From Date</th>
                                  <th>To Date</th>
                                  <th>Bank</th>
                                  <th>Branch</th>
                                </tr>
                              </thead>
                              <tbody>{renderTermDepositInTable()}</tbody>
                            </table>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ViewFund;
